import { useContext, useEffect, useState } from "react";
import FormNewCompletion from "./FormNewCompletion";
import ListNewCompletions from "./ListNewCompletions";
import { CompletionsContext, LoadingContext, TypesContext } from "../../App";
import { FormTitleContext } from "../../layout/Vertical/Global";
import { MsalInstanceContext, VariablesContext } from "../../auth/AppProvider";
import { useNavigate } from "react-router";
import { getFilteredData } from "../../utils/functions/filteredForms";
import { useSearchParams } from "react-router-dom";

function NewCompletion() {
    const [allcompletions,] = useContext(CompletionsContext);
    const [, setFormTitle] = useContext(FormTitleContext);
    const [loading, setLoading] = useContext(LoadingContext)
    const navigate = useNavigate()
    const variables = useContext(VariablesContext)
    // init state
    const [typesParameters,] = useContext(TypesContext)
    const [completions, setCompletions] = useState([]);
    const [type, setType] = useState(null);
    let [searchParams] = useSearchParams();
    const [filters, setFilters] = useState([]);
    const [view, setView] = useState("form");

    const msalInstance = useContext(MsalInstanceContext);

    useEffect(() => {
        setFormTitle(null);
    }, [variables, msalInstance])

    useEffect(() => {
        setType(typesParameters.find(t => t.selected === true));
        if (!typesParameters) {
            setLoading(false)
        }
    }, [typesParameters])

    useEffect(() => {
        if (allcompletions && allcompletions.length) {
            if (type) {
                var Ncompletions = allcompletions.filter(c => c.typeId === type.id && !c.objectAssociated)
                if (Ncompletions && Ncompletions.length > 0) {
                    setCompletions(Ncompletions);
                    setLoading(false);
                    var filtersConstruction = type.filters.map(f => { return { id: f.id, label: f.label, name: f.name, description: f.description } });
                    filtersConstruction = filtersConstruction.map(f => {
                        var valueprefiltered = false;
                        if (searchParams.get(f.id)) {
                            valueprefiltered = searchParams.get(f.id).split(",");
                        }
                        f.options = Ncompletions.map(c => c.properties.hasOwnProperty(f.name) ? { value: c.properties[f.name], label: c.properties[f.name] } : null).filter((c, index, self) => c !== null && self.findIndex(sc => sc.value === c.value) === index).filter(c => c.value !== "" && c.value !== null && c.value !== undefined).map(c => { return { value: c.value, label: c.label, actif: valueprefiltered ? valueprefiltered.find(v => v === c.value) : false } });
                        f.options.sort((a, b) => a.label.localeCompare(b.label))
                        if (f.options == null || f.options.length === 0) {
                            return null;
                        }
                        return f;
                    }).filter(f => f !== null);
                    if (filtersConstruction && filtersConstruction.length > 0) {
                        setFilters(filtersConstruction);
                    } else {
                        setView("list")
                    }
                }
                else {
                    navigate("/")
                }
            }
        }
    }, [allcompletions, msalInstance, type])

    function onDataChange(data, filtersLoc) {
        var fullFilteredData = getFilteredData(filtersLoc, data)
        var filteredData = data;
        var filteredOptions = [];
        filtersLoc.forEach(filterLoc => {
            var options = filterLoc.options.map(opt => {
                var vl = filteredData.filter(fD => fD.properties?.[filterLoc.name] === opt.value);
                var am = fullFilteredData.filter(fD => fD.properties?.[filterLoc.name] === opt.value).length;
                return { ...opt, hidden: vl.length ? false : true, amount: am }
            })
            filteredOptions.push({
                id: filterLoc.id,
                name: filterLoc.name,
                options: options,
                label: filterLoc.label,
                description: filterLoc.description
            })
            filteredData = getFilteredData(filteredOptions, filteredData)
        })
        setFilters(filteredOptions)
    }

    return <div className=" h-screen">{loading ? null : (view === "form" ? <FormNewCompletion completions={completions} filters={filters} onDataChange={onDataChange} setView={() => { setView("list") }} />
        : (view === "list" ? <ListNewCompletions type={type} completions={completions} setFilters={setFilters} filters={filters} setView={setView} /> : null))}</div>
}

export default NewCompletion;